import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import { BodyText, theme, useNavbarContainerHeight, useResponsive, VStack } from '@sg/garnish';

import { useTrademark } from '../../../../../hooks/useTrademark';
import { DebugMenuTrigger } from '../../../../DebugMenu';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountMenuFooter = () => {
  const trademark = useTrademark();

  const { currentBreakpoint, match } = useResponsive();
  const { paddingBottomStyle: navbarPaddingBottomStyle } = useNavbarContainerHeight();

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldRenderTrademark = match([Boolean(Platform.OS !== 'web' && trademark), false]);
  const shouldApplyNavbarPadding = Platform.OS !== 'web' && currentBreakpoint.isXS;

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [
    styles.container,
    shouldApplyNavbarPadding ? navbarPaddingBottomStyle : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <VStack testID="account-menu-footer" style={containerStyles} gap={theme.spacing['4']}>
      {shouldRenderTrademark ? <BodyText sizeMatch={['14', '16']}>{trademark}</BodyText> : null}
      <DebugMenuTrigger />
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: theme.spacing['6'],
  },
});
